module.exports = __webpack_public_path__ + "fonts/founders-grotesk-regular.f972133.woff2";